import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { BILLING_REPORT_RETENTION_COLUMNS } from '../../../../config/columns';
import {
  clearBillingRetention,
  getBillingRetention,
} from '../../../../actions';
import {
  BILLING_PATH,
  BILLING_REPORT_RETENTION_PATH,
} from '../../../../config/paths';

export const BillProcessRetentionReversions = ({
  breadcrumbs,
  billingReportRetentions,
  loading,
  dispatchGetBillingRetention,
  dispatchClearBillingRetention,
}) => {
  useLayoutEffect(() => () => dispatchClearBillingRetention(), []);

  const data = billingReportRetentions.get('content') || [];
  const pages = billingReportRetentions.get('totalPages') || null;
  const defaultPageSize =
    billingReportRetentions.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Retenciones y Reversiones"
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: BILLING_REPORT_RETENTION_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBillingRetention,
        modelPath: BILLING_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetBillingRetention: getBillingRetention,
  dispatchClearBillingRetention: clearBillingRetention,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Retenciones y Reversiones',
      href: BILLING_REPORT_RETENTION_PATH,
    },
  ],
  billingReportRetentions: AccountingUnit.Billing.getIn([
    'retention',
    'content',
  ]),
  loading: AccountingUnit.Billing.getIn(['retention', 'loading']),
});

BillProcessRetentionReversions.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  billingReportRetentions: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetBillingRetention: PropTypes.func.isRequired,
  dispatchClearBillingRetention: PropTypes.func.isRequired,
};

BillProcessRetentionReversions.defaultProps = {
  billingReportRetentions: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillProcessRetentionReversions);
